// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__21aW7","actionsCol":"EnrolledClinics_actionsCol__r0ZMQ"};